/**
 * /frontend/src/features/analytics/hooks/useAppointmentAnalytics.js
 */

import { useCallback, useMemo } from 'react';
import { getAppointmentByService, getAppointmentPopularSlots, getAppointmentSummary, getAppointmentTrend } from '../api/appointmentAnalyticsApi';
import useAnalyticsResource from './useAnalyticsResource';

/**
 * Loads appointment analytics data.
 * @param {Object} params
 * @returns {{data:any,isLoading:boolean,isError:boolean,error:any,refetch:Function}}
 */
const useAppointmentAnalytics = (params = {}) => {
  const { request, storeToken, storeUuid, startDate, endDate, granularity, refreshSignal } = params;
  const enabled = Boolean(request && storeUuid);

  const fetcher = useCallback(async () => {
    const [summary, trend, popularSlots, byService] = await Promise.all([
      getAppointmentSummary(request, storeToken, storeUuid, startDate, endDate),
      getAppointmentTrend(request, storeToken, storeUuid, startDate, endDate, granularity),
      getAppointmentPopularSlots(request, storeToken, storeUuid, startDate, endDate),
      getAppointmentByService(request, storeToken, storeUuid, startDate, endDate),
    ]);
    return { summary, trend, popularSlots, byService };
  }, [endDate, granularity, request, startDate, storeToken, storeUuid]);

  const resource = useAnalyticsResource(enabled, fetcher, 'useAppointmentAnalytics', refreshSignal);
  return useMemo(() => resource, [resource]);
};

export default useAppointmentAnalytics;
